import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from "@/pages/home/index.vue";
import Clause from "@/pages/clause/index.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/caluse',
    name: 'clause',
    component: Clause//() => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
